"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconMy = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconMy = function SvgIconMy(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.60002 6.00002C1.60002 3.56997 3.56997 1.60002 6.00002 1.60002C8.43008 1.60002 10.4 3.56997 10.4 6.00002C10.4 8.43008 8.43008 10.4 6.00002 10.4C3.56997 10.4 1.60002 8.43008 1.60002 6.00002ZM6.00002 0.400024C2.90723 0.400024 0.400024 2.90723 0.400024 6.00002C0.400024 9.09282 2.90723 11.6 6.00002 11.6C9.09282 11.6 11.6 9.09282 11.6 6.00002C11.6 2.90723 9.09282 0.400024 6.00002 0.400024ZM5 6H4.705C4.60611 6.00042 4.50957 6.03014 4.42757 6.08542C4.34558 6.14071 4.28183 6.21906 4.24436 6.31058C4.2069 6.40209 4.19741 6.50266 4.21711 6.59957C4.2368 6.69647 4.28479 6.78537 4.355 6.855L5.645 8.145C5.69148 8.19187 5.74678 8.22906 5.80771 8.25445C5.86864 8.27983 5.93399 8.2929 6 8.2929C6.066 8.2929 6.13135 8.27983 6.19228 8.25445C6.25321 8.22906 6.30851 8.19187 6.35499 8.145L7.64499 6.855C7.71521 6.78537 7.76319 6.69647 7.78288 6.59957C7.80258 6.50266 7.79309 6.40209 7.75563 6.31058C7.71817 6.21906 7.65441 6.14071 7.57242 6.08542C7.49042 6.03014 7.39388 6.00042 7.29499 6H6.99999V4C6.99999 3.86739 6.94732 3.74022 6.85355 3.64645C6.75978 3.55268 6.6326 3.5 6.49999 3.5H5.5C5.36739 3.5 5.24021 3.55268 5.14644 3.64645C5.05267 3.74022 5 3.86739 5 4V6Z",
    fill: "currentColor"
  }));
};

exports.SvgIconMy = SvgIconMy;